import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import styled, { css } from 'styled-components';
import { rgba } from 'polished';
export var DayButton = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 36px;\n  height: 36px;\n  margin: 2px 8px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: relative;\n  overflow: visible;\n  user-select: none;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  background-color: transparent;\n  -webkit-appearance: none;\n  -webkit-tap-highlight-color: transparent;\n  box-sizing: border-box;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  font-size: 14px;\n  font-family: ", ";\n  color: ", ";\n\n  &:hover:not(:disabled) {\n    ", "\n  }\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.fontRegular;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.calendar.textColor;
}, function (_ref3) {
  var theme = _ref3.theme,
    variant = _ref3.variant;
  if (variant !== 'selected') {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n        "])), rgba(theme.calendar.selectedTextColor, 0.5), theme.calendar.daySelectedColor);
  }
  return null;
}, function (_ref4) {
  var variant = _ref4.variant;
  if (variant === 'disabled') {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        color: ", ";\n        pointer-events: none;\n      "])), function (_ref5) {
      var theme = _ref5.theme;
      return theme.calendar.disabledTextColor;
    });
  }
  if (variant === 'selected') {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n      "])), function (_ref6) {
      var theme = _ref6.theme;
      return theme.calendar.selectedTextColor;
    }, function (_ref7) {
      var theme = _ref7.theme;
      return theme.calendar.daySelectedColor;
    });
  }
  if (variant === 'current') {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), function (_ref8) {
      var theme = _ref8.theme;
      return theme.calendar.selectedTextColor;
    });
  }
  if (variant === 'hidden') {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        opacity: 0;\n        pointer-events: none;\n      "])));
  }
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (_ref9) {
    var theme = _ref9.theme;
    return theme.calendar.textColor;
  });
});